import { object } from "superstruct";

import GiftRegistryItemSchema from "./GiftRegistryItemSchema";

const ChangeGiftRegistryItemResponseSchema = object({
    giftRegistryItem: GiftRegistryItemSchema,
});

export default ChangeGiftRegistryItemResponseSchema;
